import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { HeaderProps, HeaderRowCellProps, HeaderRowProps } from './models';
import sortArrowDown from '../../../../../assets/arrow-down-grey.svg';
import sortArrowUp from '../../../../../assets/arrow-up-grey.svg';
import { Icon } from '../../../../icon/Icon';

const HeaderRowCell = styled(({ className, cellIndex, cellAmount, column, isGrouping }: HeaderRowCellProps) => {
  const sortButton = useMemo(() => {
    if (column.isSorted)
      return <Icon className="sort-button" src={column.isSortedDesc ? sortArrowDown : sortArrowUp} />;

    return null;
  }, [column.isSorted, column.isSortedDesc]);

  return (
    <th
      {...{
        className,
        ...column.getHeaderProps(column.getSortByToggleProps()),
      }}
    >
      {isGrouping ? <span {...column.getGroupByToggleProps()}>{}</span> : null}
      {column.render('Header')}
      <span className="sort-container">{sortButton}</span>
    </th>
  );
})`
  ${styles.HeaderRowCell}
`;

const HeaderRow = styled(
  ({ className, headerGroup, hasActionsMenu, groupBy, hasExpandableArea, sortBy }: HeaderRowProps) => {
    const headerGroupProps = headerGroup.getHeaderGroupProps();

    const actionsMenuCell = hasActionsMenu ? <th className="empty-cell" /> : null;
    const expandableTemplateCell = hasExpandableArea ? <th className="empty-cell" /> : null;

    const headersGroupsCells = useMemo(() => {
      return headerGroup.headers.map((column, index) => (
        <HeaderRowCell
          {...{
            key: index,
            cellIndex: index,
            cellAmount: headerGroup.headers.length,
            column,
            isGrouping: column.canGroupBy && column.id === groupBy,
            sortBy,
          }}
        />
      ));
    }, [headerGroup, groupBy, sortBy]);

    return (
      <tr {...{ className, ...headerGroupProps }}>
        {expandableTemplateCell}
        {headersGroupsCells}
        {actionsMenuCell}
      </tr>
    );
  }
)`
  ${styles.HeaderRow}
`;

export const Header = memo(
  styled(({ className, headerGroups, groupBy, hasExpandableArea, hasActionsMenu, sortBy }: HeaderProps) => {
    return (
      <thead {...{ className }}>
        {headerGroups?.map((headerGroup, index) => (
          <HeaderRow {...{ key: index, headerGroup, groupBy, hasExpandableArea, hasActionsMenu, sortBy }} />
        ))}
      </thead>
    );
  })`
    ${styles.Header}
  `
);
